import { useCallback } from 'react';

import type { ActionsReturnType, StorySharingHookProps } from './types';

// TODO: Implement
export function useInstagramStorySharing(_input: StorySharingHookProps): ActionsReturnType {
	const primaryAction = useCallback(() => {}, []);

	return {
		primaryAction,
		secondaryAction: undefined,
	};
}
